module.exports = __webpack_public_path__ + "img/upload.caf2139a.svg";